import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const NextIcon = withSvgIcon(
    <g>
        <path d="M336.2 399.2l148.5-148.5-149.8-149.9-30.7 30.8 97.3 97.3H15.3v43.5h386.2l-96 96z" />
    </g>
);
